<template>
  <el-config-provider :locale="langStore.lang">
    <div class="main" v-if="userStore.token" ref="mainRef">
      <leftChat ref="leftChatRef" />
      <main
        class="content-main"
        :style="{ width: `calc(100vw - ${mainWidth}px - ${collapseMenu}rem)` }"
      >
        <Header @toggleCollapse="toggleCollapse" :isCollapse="isCollapse" />
        <RouterView />
      </main>
    </div>
    <Login v-if="!userStore.token" />

    <ChatTranslate v-if="changeStore.visible" />
    <!-- 截图功能 -->
    <CropperVue v-if="cropperStore.visible" />

     <!-- iPad / 平板横屏提示 -->
     <div v-if="showLandscapeTip" class="landscape-tip">
      <el-alert
        type="warning"
        show-icon
        closable
        :title="$t('t_landscape_tip_title')"
        :description="$t('t_landscape_tip_desc')"
        @close="handleCloseLandscapeTip"
      />
    </div>
  </el-config-provider>
</template>

<script lang="ts" setup>
import {
  getCurrentInstance,
  ref,
  createApp,
  onMounted,
  watchEffect,
  onBeforeUnmount,
  watch
} from 'vue'
import { RouterView, useRouter } from 'vue-router'
import leftChat from './views/customer/component/left-chat.vue'
import Header from './views/header-nav/index.vue'

import {
  useUserStore,
  useWebSocketStore,
  useLangStore,
  useTranslatChangeStore,
  useCropperStore,
  useSliderStore
} from './stores'
import Login from './views/login/index.vue'
import { useI18n } from 'vue-i18n'
import ChatTranslate from '@/components/chat-translate/index.vue'
import CropperVue from '@/components/cropper/index.vue'
import { isSupportedNotification } from '@/utils/check'
import { ElMessage, ElMessageBox } from 'element-plus'
import Popover from '@/components/popover/index.vue'
import Tabs from '@/components/tabs/index.vue'
import Dialog from '@/components/dialog/index.vue'
import moment from 'moment'
import '@/assets/msg.scss'
import '@/assets/popover.scss'
import router, { setupRoutes } from './router'
import { Mounted } from '@icon-park/vue-next'
const userStore = useUserStore()
const webSocketStore = useWebSocketStore()
const langStore = useLangStore()
const changeStore = useTranslatChangeStore()
const cropperStore = useCropperStore()
const { locale } = useI18n()
let beforeunloadData: any
const showMenu = ref(false)
const app = createApp({})
app.component('Popover', Popover)

const showLandscapeTip = ref(false)
const landscapeTipClosed = ref(false)

const checkLandscapeTip = () => {
  const width = window.innerWidth
  const height = window.innerHeight

  // 竖屏才提示横屏
  const isPortrait = height > width

  // iPad 判断，兼容 iPadOS 13+ 伪装成 Mac
  const isIPad =
    /iPad/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

  // 平板尺寸兜底
  const isTabletSize = width >= 768 && width <= 1366 && height >= 768

  // 未登录不提示，关闭后不再提示
  showLandscapeTip.value =
    !!userStore.token &&
    isPortrait &&
    (isIPad || isTabletSize) &&
    !landscapeTipClosed.value
}

const handleCloseLandscapeTip = () => {
  landscapeTipClosed.value = true
  showLandscapeTip.value = false
}

const mainWidth = ref(0)
const mainRef = ref(null)
// let routerpath = JSON.parse(localStorage.getItem('routerpath'))?.to
onMounted(async () => {
  checkLandscapeTip()
  window.addEventListener('resize', checkLandscapeTip)
  window.addEventListener('orientationchange', checkLandscapeTip)
  await setupRoutes()
})
onBeforeUnmount(() => {
  window.removeEventListener('resize', checkLandscapeTip)
  window.removeEventListener('orientationchange', checkLandscapeTip)
})
const collapseMenu = ref(0)
const leftChatRef = ref()
const isCollapse = ref(true)
const toggleCollapse = () => {
  isCollapse.value = leftChatRef.value.toggleCollapseMenu()
}
watch(
  () => useSliderStore().isCollapse,
  (newVal, oldVal) => {
    if (newVal == false) {
      collapseMenu.value = 12
    } else {
      collapseMenu.value = 0
    }
  }
)
watch(
  () => userStore.token,
  () => {
    checkLandscapeTip()
  }
)
watchEffect(() => {
  const updateMainWidth = () => {
    if (mainRef.value) {
      mainWidth.value = mainRef.value.offsetWidth
    }
  }

  updateMainWidth()

  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      mainWidth.value = entry.contentRect.width
    }
  })

  if (mainRef.value) {
    resizeObserver.observe(mainRef.value)
  }

  return () => {
    resizeObserver.disconnect()
  }
})

//创建国际化实例
//@ts-ignore
// eslint-disable-next-line no-unsafe-optional-chaining
const { $t } = getCurrentInstance()?.appContext.config.globalProperties
window.ononline = function () {
  webSocketStore.setOnline(true)
  const status = webSocketStore.webSokcetStatus()
  if (status !== WebSocket.OPEN || status !== WebSocket.CONNECTING) {
    webSocketStore.connect()
    webSocketStore.keepHeart()
  }
}
window.onbeforeunload = function () {
  beforeunloadData = new Date().getTime()
  useRouter().push(routerpath.path)
}
// 原来这里在页面卸载（刷新/关闭页签）时会调一次「退出登录」。但后端的退出是把这个账号**所有**登录凭证
// 一起清掉（kf-user LoginService#logout），同一个账号开了两个页签/两台设备时，刷新或关掉其中一个，
// 另一个立刻变成「什么都看不到」（凭证失效），再刷新又会把别人踢掉。
// 客服在不在线本来就由 WebSocket 是否断开来决定（断开且没有别的连接就置离线），不需要靠这个退出。
// 所以不再在卸载时自动退出，只保留手动点「退出」。凭证存在各页签自己的 sessionStorage，关页签就没了。
window.onunload = function () {
  // intentionally empty
}
window.onresize = function () {
  if (window.innerWidth <= 768) {
    useUserStore().setIsPcParam(false)
  } else {
    useUserStore().setIsPcParam(true)
  }
}

//防止浏览器刷新，导致语言改变行为
locale.value = userStore.locale
const setLanguage = () => {
  const language = userStore.locale || window.navigator.language
  if (language && language.indexOf('zh') > -1) {
    moment.locale('zh')
    locale.value = 'zh'
  } else {
    moment.locale(language)
    locale.value = language
  }
}
setLanguage()
isSupportedNotification(
  $t('t_attention'),
  $t('t_user_refused_attention'),
  $t('t_browser_not_supported')
)
</script>
<style scoped>
@media screen and (min-width: 768px) {
  .main {
    height: 100vh;
    overflow-y: hidden;
    display: flex;
    flex-direction: row;
    position: relative;
    background-color: #f4f4f5;;
  }
}
@media screen and (max-width:576px) {
  .main {
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    position: relative;
    text-align: center;
    height: 100vh;
    width: 100vw;
    touch-action: pan-y;
    overflow: hidden;
  }
}
.menuClass {
  display: flex;
  flex-direction: row;
  align-items: center;
}
header {
  line-height: 1.5;
  max-height: 100vh;
}
.content-main {
  flex: 1;
  width: calc(100vw - 3.3vw);
  height: 100%;
  overflow: hidden;
}
@media (max-width: 768px) {
  .content-main {
    width: 100vw !important;
  }
}
.logo {
  display: block;
  margin: 0 auto 2rem;
}

nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}
:deep(.el-input__wrapper) {
  /* border-radius: 15px; */
  /* background: #f1f1f1; */
  border-radius: 5px;
  background-color: #fff;
}
::v-deep .el-select__wrapper {
  border-radius: 5px;
}
:deep(.el-input .el-input__count .el-input__count-inner) {
  /* background: #f1f1f1; */
  background-color: #fff;
}
:deep(.box-card) {
  border-radius: 8px !important;
  box-shadow: none !important;
  border: none;
}
.el-select .el-input.is-focus ::v-deep .el-input__inner {
  outline: none !important;
  box-shadow: none;
}
:focus-visible {
  outline: none !important;
}
@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;
    padding: 1rem 0;
    margin-top: 1rem;
  }
}

:deep(.el-notification__group) {
  width: 100% !important;
}
:deep(.el-select__input) {
  /* width: 100% !important; */
}

:deep(.el-table__border-left-patch) {
  background-color: white !important;
}
:deep(.el-table--border:after) {
  background-color: transparent !important;
}
:deep(.el-table__body .el-table__cell) {
  border-left: 1px solid transparent !important;
  border-right: 1px solid transparent !important;
}

:deep(.el-table__inner-wrapper:before) {
  background-color: transparent;
}
:deep(.el-table--border th.el-table__cell) {
  border: 1px solid white;
}
:deep(.el-alert .el-alert__close-btn){
  top: 5px;
}
.landscape-tip {
  position: fixed;
  top: 70px;
  right: 20px;
  z-index: 3000;
  width: 420px;
  max-width: calc(100vw - 32px);
}

.landscape-tip :deep(.el-alert) {
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
}

.landscape-tip :deep(.el-alert__title) {
  font-size: 15px;
  font-weight: 600;
}

.landscape-tip :deep(.el-alert__description) {
  margin-top: 4px;
  line-height: 20px;
}

@media screen and (max-width: 768px) {
  .landscape-tip {
    top: 60px;
    left: 12px;
    right: 12px;
    width: auto;
  }
}
</style>
